import {axios} from '@/utils/request'

const pub = "inspect.inspectVehicle";
/**
 * api接口列表
 */
const api = {
    info: '/' + pub + '/info',
    list: '/' + pub + '/list',
    add: '/' + pub + '/add',
    edit: '/' + pub + '/edit',
    delete: '/' + pub + '/delete',
    selectList: '/' + pub + '/selectList',
    tree_list: '/' + pub + '/treeList',
    auditInspectVehicle: '/' + pub + '/auditInspectVehicle',
    faultAuditInspectVehicle: '/' + pub + '/faultAuditInspectVehicle',
}

/**
 * 获取详细
 */
export function getInfo() {
    return axios({
        url: api.info,
        method: 'get'
    })
}

/**
 * 获取树结构项目
 */
export function getTreeList() {
    return axios({
        url: api.tree_list,
        method: 'get'
    })
}

/**
 * 列表
 */
export function list(params) {
    return axios({
        url: api.list,
        method: 'get',
        params
    })
}

/**
 * 列表
 */
export function selectList(params) {
    return axios({
        url: api.selectList,
        method: 'get',
        params
    })
}
export function auditInspectVehicle(data) {
    return axios({
        url: api.auditInspectVehicle,
        method: 'post',
        data
    })
}

export function faultAuditInspectVehicle(data) {
    return axios({
        url: api.faultAuditInspectVehicle,
        method: 'post',
        data
    })
}

/**
 * 新增记录
 * @param {*} data
 */
export function add(data) {
    return axios({
        url: api.add,
        method: 'post',
        data
    })
}

/**
 * 编辑记录
 * @param {*} data
 */
export function edit(data) {
    return axios({
        url: api.edit,
        method: 'post',
        data
    })
}

/**
 * 删除记录
 * @param {*} data
 */
export function deleted(data) {
    return axios({
        url: api.delete,
        method: 'post',
        data: data
    })
}
